/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotGroupDto,
  ApiEnvelopeBotGroupEmptyDto,
  ApiEnvelopeBotGroupListResponse,
  BotGroupSaveRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botGroupListBotGroupsResponse200 = {
  data: ApiEnvelopeBotGroupListResponse
  status: 200
}

export type botGroupListBotGroupsResponseSuccess = (botGroupListBotGroupsResponse200) & {
  headers: Headers;
};
;

export type botGroupListBotGroupsResponse = (botGroupListBotGroupsResponseSuccess)

export const getBotGroupListBotGroupsUrl = () => {




  return `/api/botgroups`
}

export const useBotGroupListBotGroupsHook = (): ( options?: RequestInit) => Promise<botGroupListBotGroupsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotGroupListBotGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botGroupCreateBotGroupResponse200 = {
  data: ApiEnvelopeBotGroupDto
  status: 200
}

export type botGroupCreateBotGroupResponse400 = {
  data: ApiEnvelopeBotGroupDto
  status: 400
}

export type botGroupCreateBotGroupResponseSuccess = (botGroupCreateBotGroupResponse200) & {
  headers: Headers;
};
export type botGroupCreateBotGroupResponseError = (botGroupCreateBotGroupResponse400) & {
  headers: Headers;
};

export type botGroupCreateBotGroupResponse = (botGroupCreateBotGroupResponseSuccess | botGroupCreateBotGroupResponseError)

export const getBotGroupCreateBotGroupUrl = () => {




  return `/api/botgroups`
}

export const useBotGroupCreateBotGroupHook = (): (botGroupSaveRequest?: BotGroupSaveRequest, options?: RequestInit) => Promise<botGroupCreateBotGroupResponse> => {

      const customFetcher = useSfetchMutator();
      return (botGroupSaveRequest?: BotGroupSaveRequest, options?: RequestInit) => {

        return customFetcher(getBotGroupCreateBotGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botGroupSaveRequest)
  }
);
      }
  }


export type botGroupUpdateBotGroupResponse200 = {
  data: ApiEnvelopeBotGroupDto
  status: 200
}

export type botGroupUpdateBotGroupResponse400 = {
  data: ApiEnvelopeBotGroupDto
  status: 400
}

export type botGroupUpdateBotGroupResponse404 = {
  data: ApiEnvelopeBotGroupDto
  status: 404
}

export type botGroupUpdateBotGroupResponseSuccess = (botGroupUpdateBotGroupResponse200) & {
  headers: Headers;
};
export type botGroupUpdateBotGroupResponseError = (botGroupUpdateBotGroupResponse400 | botGroupUpdateBotGroupResponse404) & {
  headers: Headers;
};

export type botGroupUpdateBotGroupResponse = (botGroupUpdateBotGroupResponseSuccess | botGroupUpdateBotGroupResponseError)

export const getBotGroupUpdateBotGroupUrl = (id: string,) => {




  return `/api/botgroups/${id}`
}

export const useBotGroupUpdateBotGroupHook = (): (id: string,
    botGroupSaveRequest?: BotGroupSaveRequest, options?: RequestInit) => Promise<botGroupUpdateBotGroupResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    botGroupSaveRequest?: BotGroupSaveRequest, options?: RequestInit) => {

        return customFetcher(getBotGroupUpdateBotGroupUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botGroupSaveRequest)
  }
);
      }
  }


export type botGroupDeleteBotGroupResponse200 = {
  data: ApiEnvelopeBotGroupEmptyDto
  status: 200
}

export type botGroupDeleteBotGroupResponse404 = {
  data: ApiEnvelopeBotGroupEmptyDto
  status: 404
}

export type botGroupDeleteBotGroupResponseSuccess = (botGroupDeleteBotGroupResponse200) & {
  headers: Headers;
};
export type botGroupDeleteBotGroupResponseError = (botGroupDeleteBotGroupResponse404) & {
  headers: Headers;
};

export type botGroupDeleteBotGroupResponse = (botGroupDeleteBotGroupResponseSuccess | botGroupDeleteBotGroupResponseError)

export const getBotGroupDeleteBotGroupUrl = (id: string,) => {




  return `/api/botgroups/${id}`
}

export const useBotGroupDeleteBotGroupHook = (): (id: string, options?: RequestInit) => Promise<botGroupDeleteBotGroupResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotGroupDeleteBotGroupUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


